import $ from 'jquery';

// Importing the slick carousel
import '../../node_modules/slick-carousel/slick/slick'//'../node_modules/slick-carousel/slick/slick.js';

/**
 * hero module
 *
 * @module hero
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * - Generated on 2017-08-30 using @14four/generator-excalibur 0.1.23
 * - Converted to ES6 on 2023-11-26 using ChatGPT
 */

class Hero {
  constructor(element) {
    this.$el = $(element);
    this.setupDefaults();
    this.setBinds();

    this.setupSlick();
  }

  setupDefaults() {
    this.$hint = this.$el.find('.hint');
    this.$window = $(window);
    this.$slide = this.$el.find('.slide');
  }

  setBinds() {
    this.$window.on('scroll',() => this.handleScroll());
  }

  handleScroll() {
    if (this.$window.scrollTop() > 50) {
      this.$hint.fadeOut('slow');
    } else {
      this.$hint.fadeIn('slow');
    }
  }

  setupSlick() {
    $('.heroCarousel').slick({
      autoplay: true,
      arrows: false,
      dots: false,
      infinite: true,
      speed: 1500,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: false,
      draggable: true,
      pauseOnFocus: false,
      pauseOnHover: false
    });

    // Once Page fully Loads, fade in slideshow images
    setTimeout(() => {
      $('.slide').removeClass('inactive');
    }, 400);
  }
}

// Using ES6 export statement
export default Hero;
